<h1 class="title">Document Types</h1>
<h5>Manage document usage types</h5>

<acabim-card 
    class="push-down-2"
    cardHeading="Document Usage Types"
    [cardContent]="form" 
    [isCollapsible]="true"
    [isCollapsed]="false"
    [hasHelpButton]="true"
    [helpMessage]="manageDocumentsFormMessage">
</acabim-card>

<ng-template #form>
    <div class="cas-flex-row manage-form-container">
        <acabim-form-block 
            *ngIf="isManageDocumentFormReady else loadingView" 
            class="col-md-12 manage-form" 
            labelWidth="18" 
            labelAlign="right" 
            [colonize]="true" 
            [shortFields]="true" 
            [centerInputs]="true">
            <form [formGroup]="manageDocumentsForm">
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>Current document usage types</acabim-form-input-label>
                    <acabim-form-input-content [form]="manageDocumentsForm" controlName="currentDocumentUsageTypes">
                        <div class="cas-flex-row">
                            <p-multiSelect
                                class="manage-form__dropdown"
                                appendTo="body"
                                formControlName="currentDocumentUsageTypes"
                                [options]="documentUsageTypes"
                                optionLabel="name"
                                placeholder="Choose a type"
                                [selectionLimit]="1"
                                (onChange)="selectDocumentUsageTypeHandler($event)">
                            </p-multiSelect>
                            <button class="cas-button-action manage-form__button" (click)="editDocumentUsageTypeHandler()">Edit</button>
                        </div>
                        </acabim-form-input-content>
                </acabim-form-input-wrapper>
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>Enter a new document usage type to add</acabim-form-input-label>
                    <acabim-form-input-content [form]="manageDocumentsForm" controlName="newDocumentUsageType">
                        <div class="cas-flex-row">
                            <input class="manage-form__text-field" type="text" size="5" formControlName="newDocumentUsageType">
                            <button class="cas-button-action manage-form__button" (click)="addDocumentUsageTypeHandler()">Add</button>
                        </div>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
            </form>
        </acabim-form-block>
    </div>
</ng-template>

<ng-container *ngIf="isEditModalReady">
    <acabim-modal
        width="60vw"
        fixHeight="60vh"
        [title]="'Editing: ' + selectedUsageType?.name"
        [display]="isEditModalReady"
        [footer]="false"   
        (status)="toggleEditModal($event)">
        <div class="cas-flex-row">
            <acabim-form-block class="col-md-12" labelWidth="10" labelAlign="right" [colonize]="true" [shortFields]="true" [centerInputs]="true">
                <form [formGroup]="editDocumentUsageForm">
                    <acabim-form-input-wrapper>
                        <acabim-form-input-label>Document usage type</acabim-form-input-label>
                        <acabim-form-input-content [form]="editDocumentUsageForm" controlName="documentUsageTypeName">
                            <input type="text" formControlName="documentUsageTypeName">
                        </acabim-form-input-content>
                    </acabim-form-input-wrapper>
                    <acabim-form-input-wrapper>
                        <acabim-form-input-label>Status</acabim-form-input-label>
                        <acabim-form-input-content [form]="editDocumentUsageForm" controlName="documentUsageTypeStatus">
                            <ng-container *ngFor="let status of documentStatusTypes">
                                <p-radioButton 
                                    name="documentUsageTypeStatus" 
                                    [value]="status.key" 
                                    [label]="status.name" 
                                    [inputId]="status.name"
                                    formControlName="documentUsageTypeStatus">
                                </p-radioButton>
                            </ng-container>
                        </acabim-form-input-content>
                    </acabim-form-input-wrapper>
                </form>
                <div class="cas-action-buttons cas-action-buttons-bottom">
                    <button class="cas-button-action cas-button-right" (click)="submitEditFormHandler()">Save</button>
                </div>
            </acabim-form-block>
        </div>   
    </acabim-modal>
</ng-container>

<ng-template #loadingView>
    <acabim-loading-view></acabim-loading-view>
</ng-template>

<p-toast position="center"></p-toast>
